// util/CryptoUtil.ts
import CryptoJS from 'crypto-js';

class CryptoUtil {
  private static readonly SECRET_KEY = process.env.REACT_APP_ENCRYPT_KEY || 'default-secret-key-32-chars-long-here';
  
  /**
   * 使用盐值加密数据
   */
  static encryptWithSalt(data: string): { encrypted: string; salt: string } {
    try {

      
      const salt = this.generateSalt();

      
      // 将盐值和数据组合后加密
      const dataWithSalt = data + salt;

      
      const encrypted = CryptoJS.AES.encrypt(dataWithSalt, this.SECRET_KEY).toString();
      /*console.log('加密结果:', encrypted);
      console.log('加密结果长度:', encrypted.length);
      console.log('加密结果前缀:', encrypted.substring(0, 20));
      
      console.log('=== Web端加密结束 ===');*/
      
      return { encrypted, salt };
    } catch (error) {
      console.error('盐值加密失败:', error);
      throw error;
    }
  }
  
  /**
   * 使用盐值解密数据
   */
  static decryptWithSalt(encryptedData: string, salt: string): string {
    try {
      /*console.log('=== Web端解密开始 ===');
      console.log('加密数据:', encryptedData);
      console.log('加密数据长度:', encryptedData.length);
      console.log('盐值:', salt);*/
      
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
      //console.log('解密后字节长度:', bytes.sigBytes);
      
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
     /* console.log('解密后字符串:', decryptedString);
      console.log('解密后字符串长度:', decryptedString.length);*/
      
      // 验证并移除盐值
      if (decryptedString.endsWith(salt)) {
        const result = decryptedString.slice(0, -salt.length);
        /*console.log('移除盐值后结果:', result);
        console.log('移除盐值后长度:', result.length);
        console.log('=== Web端解密结束 ===');*/
        return result;
      } else {
       // console.error('盐值验证失败 - 期望:', salt);
        //console.error('盐值验证失败 - 实际结尾:', decryptedString.substring(decryptedString.length - salt.length));
        throw new Error('盐值验证失败');
      }
    } catch (error) {
      //console.error('盐值解密失败:', error);
      throw error;
    }
  }
  
  /**
   * 加密对象（使用盐值）
   */
  static encryptObjectWithSalt(obj: any): { encrypted: string; salt: string } {
    console.log('=== 加密对象开始 ===');
    const jsonString = JSON.stringify(obj);
    console.log('对象JSON:', jsonString);
    console.log('对象JSON长度:', jsonString.length);
    const result = this.encryptWithSalt(jsonString);
    console.log('=== 加密对象结束 ===');
    return result;
  }
  
  /**
   * 解密对象（使用盐值）
   */
  static decryptObjectWithSalt(encryptedData: string, salt: string): any {
    console.log('=== 解密对象开始 ===');
    const decryptedString = this.decryptWithSalt(encryptedData, salt);
    const result = JSON.parse(decryptedString);
    console.log('解密后对象:', result);
    console.log('=== 解密对象结束 ===');
    return result;
  }
  
  /**
   * 生成随机盐值
   */
  static generateSalt(length: number = 16): string {
    const salt = CryptoJS.lib.WordArray.random(length).toString(CryptoJS.enc.Hex);
    //console.log('生成随机盐值:', salt);
    return salt;
  }
  
  /**
   * 获取CryptoJS的默认配置信息（用于调试）
   */
  static getCryptoJSConfig(): any {
    const testEncrypt = CryptoJS.AES.encrypt('test', this.SECRET_KEY);
    return {
      keySize: 256,
      ivSize: 128,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      format: CryptoJS.format.OpenSSL,
      kdf: 'OpenSSL' // CryptoJS默认使用类似OpenSSL的KDF
    };
  }
  
  /**
   * 调试CryptoJS的加密过程
   */
  static debugEncryptionProcess(data: string): void {
    console.log('=== CryptoJS加密过程调试 ===');
    
    // 1. 生成key和iv（模拟CryptoJS内部过程）
    const salt = CryptoJS.lib.WordArray.random(16);
    console.log('内部Salt:', salt.toString());
    
    const key = CryptoJS.PBKDF2(this.SECRET_KEY, salt, {
      keySize: 256 / 32,
      iterations: 1
    });
    console.log('派生Key:', key.toString());
    
    const iv = CryptoJS.PBKDF2(this.SECRET_KEY, salt, {
      keySize: 128 / 32,
      iterations: 1
    });
    console.log('派生IV:', iv.toString());
    
    // 2. 加密
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    console.log('加密结果:', encrypted.toString());
    console.log('=== 调试结束 ===');
  }
}

export default CryptoUtil;